// ------------------------------------------------------------------------------
// <auto-generated>
// This code was generated by the @augloop/code-gen tool.
// Source: https://dev.azure.com/office/ISS/_git/augloop-server?path=%2Fmodules%2Fsession-protocol%2Fsrc%2Fmessages.ts
// Changes to this file may cause incorrect behavior and will be lost upon regeneration.
// </auto-generated>
// ------------------------------------------------------------------------------
import { AnnotationResultState, ErrorResponseCode, ExecutionErrorCode, GetAnnotationsClientErrorCode, SeedingProgressCode, SessionLongPollMessageType, SessionSwapReason } from '../../messages';
import { AnnotationActivationMessage, AnnotationActivationResponse, AnnotationConfigUpdateMessage, AnnotationConfigUpdateResponse, AnnotationReleaseMessage, AnnotationReleaseResponse, AnnotationResultStateMessage, AnnotationResultsMessage, BatchedMessage, BlobUploadResponse, BridgeMessage, CacheDumpRequestMessage, CacheDumpRequestResponse, ClaimsChallengeMessage, ErrorResponse, ExecutionError, GetAnnotationsClientError, GetAnnotationsErrorInfo, GetPluginsMetadataMessage, GetPluginsMetadataResponse, KeepAlive, Message, MicroSyncMessage, OAuth2CallbackMessage, OAuth2InitMessage, OAuth2InitResponse, OAuth2InitV2Message, OAuth2InitV2Response, RateLimitErrorResponse, Response, SeedingStatusChangeMessage, ServerAuthenticationStateChangeMessage, SessionCloseMessage, SessionCloseReason, SessionConnectMessage, SessionDeleteMessage, SessionDisconnectMessage, SessionInitMessage, SessionInitResponse, SessionLongPollMessage, SessionLongPollResponse, SessionReconnectMessage, SessionSwapOnClose, StreamingRequest, StreamingResponse, SubmittedCustomMessage, SyncMessage, SyncResponse, TimeoutErrorResponse, TokenFailureMessage, TokenProvisionMessage, TokenProvisionResponse, WorkflowExecutionCompleteMessage, WorkflowGraphInitMessage, WorkflowGraphInitResponse } from '../messages.g';
import { blobValidatorInstance, itemValidatorInstance, operationErrorValidatorInstance, operationValidatorInstance, schemaObjectHeaderValidatorInstance, schemaObjectValidatorInstance } from '@augloop/types-core';
import { clientMetadataValidatorInstance } from '@augloop/schemas';
import { authTokenTypeValidatorInstance, oAuth2GrantFlowValidatorInstance, oAuth2V2LoginStatusValidatorInstance, pluginInfoValidatorInstance, pluginMetadataValidatorInstance, workflowDefinitionBaseValidatorInstance } from '@augloop/interfaces';
import { serializedNodeValidatorInstance } from '@augloop/types-debug';
import { hostConfigValidatorInstance, serverAuthenticationStateValidatorInstance } from '../../generated/validator/client-protocol-validator.g';
import { validateArray } from '@augloop/validator-common';
export class MessageValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'Message: Expected object, got undefined object for MessageValidator' };
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'Message: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'Message: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'Message: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!Message.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "Message"' };
        }
        return { success: true };
    }
}
export const messageValidatorInstance = new MessageValidator();
export class ResponseValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'Response: Expected object, got undefined object for ResponseValidator' };
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'Response: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'Response: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'Response: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!Response.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "Response"' };
        }
        return { success: true };
    }
}
export const responseValidatorInstance = new ResponseValidator();
export class StreamingResponseValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'StreamingResponse: Expected object, got undefined object for StreamingResponseValidator' };
        }
        if ((obj.seqId !== undefined) && (typeof obj.seqId !== 'string')) {
            return { success: false, error: 'StreamingResponse: Optional field "seqId" is wrong type' };
        }
        if ((obj.finalResponse !== undefined) && (typeof obj.finalResponse !== 'boolean')) {
            return { success: false, error: 'StreamingResponse: Optional field "finalResponse" is wrong type' };
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'StreamingResponse: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'StreamingResponse: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'StreamingResponse: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!StreamingResponse.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "StreamingResponse"' };
        }
        return { success: true };
    }
}
export const streamingResponseValidatorInstance = new StreamingResponseValidator();
export class StreamingRequestValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'StreamingRequest: Expected object, got undefined object for StreamingRequestValidator' };
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'StreamingRequest: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'StreamingRequest: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'StreamingRequest: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!StreamingRequest.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "StreamingRequest"' };
        }
        return { success: true };
    }
}
export const streamingRequestValidatorInstance = new StreamingRequestValidator();
export class ExecutionErrorValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'ExecutionError: Expected object, got undefined object for ExecutionErrorValidator' };
        }
        if ((obj.code !== undefined)) {
            const result = executionErrorCodeValidatorInstance.validate(obj.code);
            if (!result.success) {
                result.error = "ExecutionError.code: " + result.error;
                return result;
            }
        }
        if ((obj.error !== undefined) && (typeof obj.error !== 'string')) {
            return { success: false, error: 'ExecutionError: Optional field "error" is wrong type' };
        }
        if ((obj.retryable !== undefined) && (typeof obj.retryable !== 'boolean')) {
            return { success: false, error: 'ExecutionError: Optional field "retryable" is wrong type' };
        }
        if ((obj.resourceId !== undefined) && (typeof obj.resourceId !== 'string')) {
            return { success: false, error: 'ExecutionError: Optional field "resourceId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!ExecutionError.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "ExecutionError"' };
        }
        return { success: true };
    }
}
export const executionErrorValidatorInstance = new ExecutionErrorValidator();
export class GetAnnotationsClientErrorValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'GetAnnotationsClientError: Expected object, got undefined object for GetAnnotationsClientErrorValidator' };
        }
        if ((obj.code !== undefined)) {
            const result = getAnnotationsClientErrorCodeValidatorInstance.validate(obj.code);
            if (!result.success) {
                result.error = "GetAnnotationsClientError.code: " + result.error;
                return result;
            }
        }
        if ((obj.error !== undefined) && (typeof obj.error !== 'string')) {
            return { success: false, error: 'GetAnnotationsClientError: Optional field "error" is wrong type' };
        }
        if ((obj.retryable !== undefined) && (typeof obj.retryable !== 'boolean')) {
            return { success: false, error: 'GetAnnotationsClientError: Optional field "retryable" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!GetAnnotationsClientError.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "GetAnnotationsClientError"' };
        }
        return { success: true };
    }
}
export const getAnnotationsClientErrorValidatorInstance = new GetAnnotationsClientErrorValidator();
export class GetAnnotationsErrorInfoValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'GetAnnotationsErrorInfo: Expected object, got undefined object for GetAnnotationsErrorInfoValidator' };
        }
        if (obj.serviceError !== undefined) {
            const result = validateArray(obj.serviceError, 1, executionErrorValidatorInstance, '{ExecutionError}');
            if (!result.success) {
                result.error = "GetAnnotationsErrorInfo.serviceError: " + result.error;
                return result;
            }
        }
        if (obj.workflowError !== undefined) {
            const result = validateArray(obj.workflowError, 1, executionErrorValidatorInstance, '{ExecutionError}');
            if (!result.success) {
                result.error = "GetAnnotationsErrorInfo.workflowError: " + result.error;
                return result;
            }
        }
        if ((obj.clientError !== undefined)) {
            const result = getAnnotationsClientErrorValidatorInstance.validate(obj.clientError);
            if (!result.success) {
                result.error = "GetAnnotationsErrorInfo.clientError: " + result.error;
                return result;
            }
        }
        if ((obj.serverError !== undefined)) {
            const result = errorResponseValidatorInstance.validate(obj.serverError);
            if (!result.success) {
                result.error = "GetAnnotationsErrorInfo.serverError: " + result.error;
                return result;
            }
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!GetAnnotationsErrorInfo.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "GetAnnotationsErrorInfo"' };
        }
        return { success: true };
    }
}
export const getAnnotationsErrorInfoValidatorInstance = new GetAnnotationsErrorInfoValidator();
export class ErrorResponseValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'ErrorResponse: Expected object, got undefined object for ErrorResponseValidator' };
        }
        if (obj.error === undefined) {
            return { success: false, error: 'ErrorResponse: Required field "error" is missing' };
        }
        else if (typeof obj.error !== 'string') {
            return { success: false, error: 'ErrorResponse: Required field "error" is wrong type' };
        }
        if ((obj.code !== undefined)) {
            const result = errorResponseCodeValidatorInstance.validate(obj.code);
            if (!result.success) {
                result.error = "ErrorResponse.code: " + result.error;
                return result;
            }
        }
        if ((obj.retryable !== undefined) && (typeof obj.retryable !== 'boolean')) {
            return { success: false, error: 'ErrorResponse: Optional field "retryable" is wrong type' };
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'ErrorResponse: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'ErrorResponse: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'ErrorResponse: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!ErrorResponse.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "ErrorResponse"' };
        }
        return { success: true };
    }
}
export const errorResponseValidatorInstance = new ErrorResponseValidator();
export class TimeoutErrorResponseValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'TimeoutErrorResponse: Expected object, got undefined object for TimeoutErrorResponseValidator' };
        }
        if (obj.error === undefined) {
            return { success: false, error: 'TimeoutErrorResponse: Required field "error" is missing' };
        }
        else if (typeof obj.error !== 'string') {
            return { success: false, error: 'TimeoutErrorResponse: Required field "error" is wrong type' };
        }
        if ((obj.code !== undefined)) {
            const result = errorResponseCodeValidatorInstance.validate(obj.code);
            if (!result.success) {
                result.error = "TimeoutErrorResponse.code: " + result.error;
                return result;
            }
        }
        if ((obj.retryable !== undefined) && (typeof obj.retryable !== 'boolean')) {
            return { success: false, error: 'TimeoutErrorResponse: Optional field "retryable" is wrong type' };
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'TimeoutErrorResponse: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'TimeoutErrorResponse: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'TimeoutErrorResponse: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!TimeoutErrorResponse.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "TimeoutErrorResponse"' };
        }
        return { success: true };
    }
}
export const timeoutErrorResponseValidatorInstance = new TimeoutErrorResponseValidator();
export class RateLimitErrorResponseValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'RateLimitErrorResponse: Expected object, got undefined object for RateLimitErrorResponseValidator' };
        }
        if (obj.retryAfterMs === undefined) {
            return { success: false, error: 'RateLimitErrorResponse: Required field "retryAfterMs" is missing' };
        }
        else if (typeof obj.retryAfterMs !== 'number') {
            return { success: false, error: 'RateLimitErrorResponse: Required field "retryAfterMs" is wrong type' };
        }
        if (obj.error === undefined) {
            return { success: false, error: 'RateLimitErrorResponse: Required field "error" is missing' };
        }
        else if (typeof obj.error !== 'string') {
            return { success: false, error: 'RateLimitErrorResponse: Required field "error" is wrong type' };
        }
        if ((obj.code !== undefined)) {
            const result = errorResponseCodeValidatorInstance.validate(obj.code);
            if (!result.success) {
                result.error = "RateLimitErrorResponse.code: " + result.error;
                return result;
            }
        }
        if ((obj.retryable !== undefined) && (typeof obj.retryable !== 'boolean')) {
            return { success: false, error: 'RateLimitErrorResponse: Optional field "retryable" is wrong type' };
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'RateLimitErrorResponse: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'RateLimitErrorResponse: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'RateLimitErrorResponse: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!RateLimitErrorResponse.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "RateLimitErrorResponse"' };
        }
        return { success: true };
    }
}
export const rateLimitErrorResponseValidatorInstance = new RateLimitErrorResponseValidator();
export class SessionInitMessageValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'SessionInitMessage: Expected object, got undefined object for SessionInitMessageValidator' };
        }
        if (obj.protocolVersion === undefined) {
            return { success: false, error: 'SessionInitMessage: Required field "protocolVersion" is missing' };
        }
        else if (typeof obj.protocolVersion !== 'number') {
            return { success: false, error: 'SessionInitMessage: Required field "protocolVersion" is wrong type' };
        }
        if (obj.clientMetadata === undefined) {
            return { success: false, error: 'SessionInitMessage: Required field "clientMetadata" is missing' };
        }
        else {
            const result = clientMetadataValidatorInstance.validate(obj.clientMetadata);
            if (!result.success) {
                result.error = "SessionInitMessage.clientMetadata: " + result.error;
                return result;
            }
        }
        if ((obj.serviceUrl !== undefined) && (typeof obj.serviceUrl !== 'string')) {
            return { success: false, error: 'SessionInitMessage: Optional field "serviceUrl" is wrong type' };
        }
        if ((obj.sessionKey !== undefined) && (typeof obj.sessionKey !== 'string')) {
            return { success: false, error: 'SessionInitMessage: Optional field "sessionKey" is wrong type' };
        }
        if ((obj.origin !== undefined) && (typeof obj.origin !== 'string')) {
            return { success: false, error: 'SessionInitMessage: Optional field "origin" is wrong type' };
        }
        if ((obj.authToken !== undefined) && (typeof obj.authToken !== 'string')) {
            return { success: false, error: 'SessionInitMessage: Optional field "authToken" is wrong type' };
        }
        if (obj.extensionConfigs !== undefined) {
            const result = validateArray(obj.extensionConfigs, 1, schemaObjectValidatorInstance, '{SchemaObject}');
            if (!result.success) {
                result.error = "SessionInitMessage.extensionConfigs: " + result.error;
                return result;
            }
        }
        if ((obj.returnWorkflowInputTypes !== undefined) && (typeof obj.returnWorkflowInputTypes !== 'boolean')) {
            return { success: false, error: 'SessionInitMessage: Optional field "returnWorkflowInputTypes" is wrong type' };
        }
        if ((obj.enableSessionInspectorLogs !== undefined) && (typeof obj.enableSessionInspectorLogs !== 'boolean')) {
            return { success: false, error: 'SessionInitMessage: Optional field "enableSessionInspectorLogs" is wrong type' };
        }
        if ((obj.enableRemoteExecutionNotification !== undefined) && (typeof obj.enableRemoteExecutionNotification !== 'boolean')) {
            return { success: false, error: 'SessionInitMessage: Optional field "enableRemoteExecutionNotification" is wrong type' };
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'SessionInitMessage: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'SessionInitMessage: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'SessionInitMessage: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!SessionInitMessage.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "SessionInitMessage"' };
        }
        return { success: true };
    }
}
export const sessionInitMessageValidatorInstance = new SessionInitMessageValidator();
export class SessionInitResponseValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'SessionInitResponse: Expected object, got undefined object for SessionInitResponseValidator' };
        }
        if (obj.sessionKey === undefined) {
            return { success: false, error: 'SessionInitResponse: Required field "sessionKey" is missing' };
        }
        else if (typeof obj.sessionKey !== 'string') {
            return { success: false, error: 'SessionInitResponse: Required field "sessionKey" is wrong type' };
        }
        if (obj.sessionUrlBase === undefined) {
            return { success: false, error: 'SessionInitResponse: Required field "sessionUrlBase" is missing' };
        }
        else if (typeof obj.sessionUrlBase !== 'string') {
            return { success: false, error: 'SessionInitResponse: Required field "sessionUrlBase" is wrong type' };
        }
        if (obj.origin === undefined) {
            return { success: false, error: 'SessionInitResponse: Required field "origin" is missing' };
        }
        else if (typeof obj.origin !== 'string') {
            return { success: false, error: 'SessionInitResponse: Required field "origin" is wrong type' };
        }
        if ((obj.sliceUrl !== undefined) && (typeof obj.sliceUrl !== 'string')) {
            return { success: false, error: 'SessionInitResponse: Optional field "sliceUrl" is wrong type' };
        }
        if ((obj.forceReconnect !== undefined) && (typeof obj.forceReconnect !== 'boolean')) {
            return { success: false, error: 'SessionInitResponse: Optional field "forceReconnect" is wrong type' };
        }
        if ((obj.tokenExpirationTime !== undefined) && (typeof obj.tokenExpirationTime !== 'number')) {
            return { success: false, error: 'SessionInitResponse: Optional field "tokenExpirationTime" is wrong type' };
        }
        if ((obj.tokenExpirationSeconds !== undefined) && (typeof obj.tokenExpirationSeconds !== 'number')) {
            return { success: false, error: 'SessionInitResponse: Optional field "tokenExpirationSeconds" is wrong type' };
        }
        if ((obj.anonymousToken !== undefined) && (typeof obj.anonymousToken !== 'string')) {
            return { success: false, error: 'SessionInitResponse: Optional field "anonymousToken" is wrong type' };
        }
        if ((obj.existingTokenProvisionResponse !== undefined)) {
            const result = tokenProvisionResponseValidatorInstance.validate(obj.existingTokenProvisionResponse);
            if (!result.success) {
                result.error = "SessionInitResponse.existingTokenProvisionResponse: " + result.error;
                return result;
            }
        }
        if (obj.workflowInputTypes !== undefined) {
            const result = validateArray(obj.workflowInputTypes, 1, undefined, 'string');
            if (!result.success) {
                result.error = "SessionInitResponse.workflowInputTypes: " + result.error;
                return result;
            }
        }
        if ((obj.maxRPS !== undefined) && (typeof obj.maxRPS !== 'number')) {
            return { success: false, error: 'SessionInitResponse: Optional field "maxRPS" is wrong type' };
        }
        if ((obj.maxBPS !== undefined) && (typeof obj.maxBPS !== 'number')) {
            return { success: false, error: 'SessionInitResponse: Optional field "maxBPS" is wrong type' };
        }
        if (obj.downstreamRuntimeWorkflows !== undefined) {
            const result = validateArray(obj.downstreamRuntimeWorkflows, 1, workflowDefinitionBaseValidatorInstance, '{WorkflowDefinitionBase}');
            if (!result.success) {
                result.error = "SessionInitResponse.downstreamRuntimeWorkflows: " + result.error;
                return result;
            }
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'SessionInitResponse: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'SessionInitResponse: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'SessionInitResponse: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!SessionInitResponse.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "SessionInitResponse"' };
        }
        return { success: true };
    }
}
export const sessionInitResponseValidatorInstance = new SessionInitResponseValidator();
export class SessionLongPollMessageValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'SessionLongPollMessage: Expected object, got undefined object for SessionLongPollMessageValidator' };
        }
        if ((obj.longPollTimeoutHint !== undefined) && (typeof obj.longPollTimeoutHint !== 'number')) {
            return { success: false, error: 'SessionLongPollMessage: Optional field "longPollTimeoutHint" is wrong type' };
        }
        if ((obj.type !== undefined)) {
            const result = sessionLongPollMessageTypeValidatorInstance.validate(obj.type);
            if (!result.success) {
                result.error = "SessionLongPollMessage.type: " + result.error;
                return result;
            }
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'SessionLongPollMessage: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'SessionLongPollMessage: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'SessionLongPollMessage: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!SessionLongPollMessage.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "SessionLongPollMessage"' };
        }
        return { success: true };
    }
}
export const sessionLongPollMessageValidatorInstance = new SessionLongPollMessageValidator();
export class SessionLongPollResponseValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'SessionLongPollResponse: Expected object, got undefined object for SessionLongPollResponseValidator' };
        }
        if (obj.batch !== undefined) {
            const result = validateArray(obj.batch, 1, schemaObjectValidatorInstance, '{SchemaObject}');
            if (!result.success) {
                result.error = "SessionLongPollResponse.batch: " + result.error;
                return result;
            }
        }
        if ((obj.error !== undefined) && (typeof obj.error !== 'string')) {
            return { success: false, error: 'SessionLongPollResponse: Optional field "error" is wrong type' };
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'SessionLongPollResponse: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'SessionLongPollResponse: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'SessionLongPollResponse: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!SessionLongPollResponse.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "SessionLongPollResponse"' };
        }
        return { success: true };
    }
}
export const sessionLongPollResponseValidatorInstance = new SessionLongPollResponseValidator();
export class SessionCloseReasonValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'SessionCloseReason: Expected object, got undefined object for SessionCloseReasonValidator' };
        }
        if (obj.reasonDescription === undefined) {
            return { success: false, error: 'SessionCloseReason: Required field "reasonDescription" is missing' };
        }
        else if (typeof obj.reasonDescription !== 'string') {
            return { success: false, error: 'SessionCloseReason: Required field "reasonDescription" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!SessionCloseReason.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "SessionCloseReason"' };
        }
        return { success: true };
    }
}
export const sessionCloseReasonValidatorInstance = new SessionCloseReasonValidator();
export class SessionSwapOnCloseValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'SessionSwapOnClose: Expected object, got undefined object for SessionSwapOnCloseValidator' };
        }
        if (obj.newDocSessionId === undefined) {
            return { success: false, error: 'SessionSwapOnClose: Required field "newDocSessionId" is missing' };
        }
        else if (typeof obj.newDocSessionId !== 'string') {
            return { success: false, error: 'SessionSwapOnClose: Required field "newDocSessionId" is wrong type' };
        }
        if (obj.reason === undefined) {
            return { success: false, error: 'SessionSwapOnClose: Required field "reason" is missing' };
        }
        else {
            const result = sessionSwapReasonValidatorInstance.validate(obj.reason);
            if (!result.success) {
                result.error = "SessionSwapOnClose.reason: " + result.error;
                return result;
            }
        }
        if (obj.reasonDescription === undefined) {
            return { success: false, error: 'SessionSwapOnClose: Required field "reasonDescription" is missing' };
        }
        else if (typeof obj.reasonDescription !== 'string') {
            return { success: false, error: 'SessionSwapOnClose: Required field "reasonDescription" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!SessionSwapOnClose.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "SessionSwapOnClose"' };
        }
        return { success: true };
    }
}
export const sessionSwapOnCloseValidatorInstance = new SessionSwapOnCloseValidator();
export class SessionCloseMessageValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'SessionCloseMessage: Expected object, got undefined object for SessionCloseMessageValidator' };
        }
        if ((obj.reconnectAllowed !== undefined) && (typeof obj.reconnectAllowed !== 'boolean')) {
            return { success: false, error: 'SessionCloseMessage: Optional field "reconnectAllowed" is wrong type' };
        }
        if ((obj.reason !== undefined)) {
            const result = schemaObjectValidatorInstance.validate(obj.reason);
            if (!result.success) {
                result.error = "SessionCloseMessage.reason: " + result.error;
                return result;
            }
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'SessionCloseMessage: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'SessionCloseMessage: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'SessionCloseMessage: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!SessionCloseMessage.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "SessionCloseMessage"' };
        }
        return { success: true };
    }
}
export const sessionCloseMessageValidatorInstance = new SessionCloseMessageValidator();
export class CacheDumpRequestMessageValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'CacheDumpRequestMessage: Expected object, got undefined object for CacheDumpRequestMessageValidator' };
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'CacheDumpRequestMessage: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'CacheDumpRequestMessage: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'CacheDumpRequestMessage: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!CacheDumpRequestMessage.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "CacheDumpRequestMessage"' };
        }
        return { success: true };
    }
}
export const cacheDumpRequestMessageValidatorInstance = new CacheDumpRequestMessageValidator();
export class CacheDumpRequestResponseValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'CacheDumpRequestResponse: Expected object, got undefined object for CacheDumpRequestResponseValidator' };
        }
        if (obj.serializedNodes === undefined) {
            return { success: false, error: 'CacheDumpRequestResponse: Required field "serializedNodes" is missing' };
        }
        else {
            const result = validateArray(obj.serializedNodes, 1, serializedNodeValidatorInstance, '{SerializedNode}');
            if (!result.success) {
                result.error = "CacheDumpRequestResponse.serializedNodes: " + result.error;
                return result;
            }
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'CacheDumpRequestResponse: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'CacheDumpRequestResponse: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'CacheDumpRequestResponse: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!CacheDumpRequestResponse.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "CacheDumpRequestResponse"' };
        }
        return { success: true };
    }
}
export const cacheDumpRequestResponseValidatorInstance = new CacheDumpRequestResponseValidator();
export class AnnotationActivationMessageValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'AnnotationActivationMessage: Expected object, got undefined object for AnnotationActivationMessageValidator' };
        }
        if (obj.annotationType === undefined) {
            return { success: false, error: 'AnnotationActivationMessage: Required field "annotationType" is missing' };
        }
        else if (typeof obj.annotationType !== 'string') {
            return { success: false, error: 'AnnotationActivationMessage: Required field "annotationType" is wrong type' };
        }
        if (obj.token === undefined) {
            return { success: false, error: 'AnnotationActivationMessage: Required field "token" is missing' };
        }
        else if (typeof obj.token !== 'string') {
            return { success: false, error: 'AnnotationActivationMessage: Required field "token" is wrong type' };
        }
        if ((obj.batchId !== undefined) && (typeof obj.batchId !== 'string')) {
            return { success: false, error: 'AnnotationActivationMessage: Optional field "batchId" is wrong type' };
        }
        if ((obj.config !== undefined)) {
            const result = schemaObjectValidatorInstance.validate(obj.config);
            if (!result.success) {
                result.error = "AnnotationActivationMessage.config: " + result.error;
                return result;
            }
        }
        if ((obj.ignoreExistingAnnotations !== undefined) && (typeof obj.ignoreExistingAnnotations !== 'boolean')) {
            return { success: false, error: 'AnnotationActivationMessage: Optional field "ignoreExistingAnnotations" is wrong type' };
        }
        if ((obj.sendStateUpdates !== undefined) && (typeof obj.sendStateUpdates !== 'boolean')) {
            return { success: false, error: 'AnnotationActivationMessage: Optional field "sendStateUpdates" is wrong type' };
        }
        if ((obj.sendApologies !== undefined) && (typeof obj.sendApologies !== 'boolean')) {
            return { success: false, error: 'AnnotationActivationMessage: Optional field "sendApologies" is wrong type' };
        }
        if (obj.scope !== undefined) {
            const result = validateArray(obj.scope, 1, undefined, 'string');
            if (!result.success) {
                result.error = "AnnotationActivationMessage.scope: " + result.error;
                return result;
            }
        }
        if ((obj.forceReturnCachedAnnotations !== undefined) && (typeof obj.forceReturnCachedAnnotations !== 'boolean')) {
            return { success: false, error: 'AnnotationActivationMessage: Optional field "forceReturnCachedAnnotations" is wrong type' };
        }
        if ((obj.returnAnnotationDoesNotExist !== undefined) && (typeof obj.returnAnnotationDoesNotExist !== 'boolean')) {
            return { success: false, error: 'AnnotationActivationMessage: Optional field "returnAnnotationDoesNotExist" is wrong type' };
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'AnnotationActivationMessage: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'AnnotationActivationMessage: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'AnnotationActivationMessage: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!AnnotationActivationMessage.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "AnnotationActivationMessage"' };
        }
        return { success: true };
    }
}
export const annotationActivationMessageValidatorInstance = new AnnotationActivationMessageValidator();
export class AnnotationActivationResponseValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'AnnotationActivationResponse: Expected object, got undefined object for AnnotationActivationResponseValidator' };
        }
        if (obj.token === undefined) {
            return { success: false, error: 'AnnotationActivationResponse: Required field "token" is missing' };
        }
        else if (typeof obj.token !== 'string') {
            return { success: false, error: 'AnnotationActivationResponse: Required field "token" is wrong type' };
        }
        if ((obj.annotationNotExists !== undefined) && (typeof obj.annotationNotExists !== 'boolean')) {
            return { success: false, error: 'AnnotationActivationResponse: Optional field "annotationNotExists" is wrong type' };
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'AnnotationActivationResponse: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'AnnotationActivationResponse: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'AnnotationActivationResponse: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!AnnotationActivationResponse.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "AnnotationActivationResponse"' };
        }
        return { success: true };
    }
}
export const annotationActivationResponseValidatorInstance = new AnnotationActivationResponseValidator();
export class AnnotationResultStateUpdateValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'AnnotationResultStateUpdate: Expected object, got undefined object for AnnotationResultStateUpdateValidator' };
        }
        if (obj.annotationType === undefined) {
            return { success: false, error: 'AnnotationResultStateUpdate: Required field "annotationType" is missing' };
        }
        else if (typeof obj.annotationType !== 'string') {
            return { success: false, error: 'AnnotationResultStateUpdate: Required field "annotationType" is wrong type' };
        }
        if (obj.state === undefined) {
            return { success: false, error: 'AnnotationResultStateUpdate: Required field "state" is missing' };
        }
        else {
            const result = annotationResultStateValidatorInstance.validate(obj.state);
            if (!result.success) {
                result.error = "AnnotationResultStateUpdate.state: " + result.error;
                return result;
            }
        }
        return { success: true };
    }
}
export const annotationResultStateUpdateValidatorInstance = new AnnotationResultStateUpdateValidator();
export class AnnotationResultStateMessageValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'AnnotationResultStateMessage: Expected object, got undefined object for AnnotationResultStateMessageValidator' };
        }
        if (obj.updates === undefined) {
            return { success: false, error: 'AnnotationResultStateMessage: Required field "updates" is missing' };
        }
        else {
            const result = validateArray(obj.updates, 1, annotationResultStateUpdateValidatorInstance, '{AnnotationResultStateUpdate}');
            if (!result.success) {
                result.error = "AnnotationResultStateMessage.updates: " + result.error;
                return result;
            }
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'AnnotationResultStateMessage: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'AnnotationResultStateMessage: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'AnnotationResultStateMessage: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!AnnotationResultStateMessage.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "AnnotationResultStateMessage"' };
        }
        return { success: true };
    }
}
export const annotationResultStateMessageValidatorInstance = new AnnotationResultStateMessageValidator();
export class AnnotationReleaseMessageValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'AnnotationReleaseMessage: Expected object, got undefined object for AnnotationReleaseMessageValidator' };
        }
        if (obj.token === undefined) {
            return { success: false, error: 'AnnotationReleaseMessage: Required field "token" is missing' };
        }
        else if (typeof obj.token !== 'string') {
            return { success: false, error: 'AnnotationReleaseMessage: Required field "token" is wrong type' };
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'AnnotationReleaseMessage: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'AnnotationReleaseMessage: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'AnnotationReleaseMessage: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!AnnotationReleaseMessage.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "AnnotationReleaseMessage"' };
        }
        return { success: true };
    }
}
export const annotationReleaseMessageValidatorInstance = new AnnotationReleaseMessageValidator();
export class AnnotationReleaseResponseValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'AnnotationReleaseResponse: Expected object, got undefined object for AnnotationReleaseResponseValidator' };
        }
        if (obj.lastRelease === undefined) {
            return { success: false, error: 'AnnotationReleaseResponse: Required field "lastRelease" is missing' };
        }
        else if (typeof obj.lastRelease !== 'boolean') {
            return { success: false, error: 'AnnotationReleaseResponse: Required field "lastRelease" is wrong type' };
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'AnnotationReleaseResponse: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'AnnotationReleaseResponse: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'AnnotationReleaseResponse: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!AnnotationReleaseResponse.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "AnnotationReleaseResponse"' };
        }
        return { success: true };
    }
}
export const annotationReleaseResponseValidatorInstance = new AnnotationReleaseResponseValidator();
export class AnnotationConfigUpdateMessageValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'AnnotationConfigUpdateMessage: Expected object, got undefined object for AnnotationConfigUpdateMessageValidator' };
        }
        if (obj.token === undefined) {
            return { success: false, error: 'AnnotationConfigUpdateMessage: Required field "token" is missing' };
        }
        else if (typeof obj.token !== 'string') {
            return { success: false, error: 'AnnotationConfigUpdateMessage: Required field "token" is wrong type' };
        }
        if (obj.config === undefined) {
            return { success: false, error: 'AnnotationConfigUpdateMessage: Required field "config" is missing' };
        }
        else {
            const result = schemaObjectValidatorInstance.validate(obj.config);
            if (!result.success) {
                result.error = "AnnotationConfigUpdateMessage.config: " + result.error;
                return result;
            }
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'AnnotationConfigUpdateMessage: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'AnnotationConfigUpdateMessage: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'AnnotationConfigUpdateMessage: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!AnnotationConfigUpdateMessage.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "AnnotationConfigUpdateMessage"' };
        }
        return { success: true };
    }
}
export const annotationConfigUpdateMessageValidatorInstance = new AnnotationConfigUpdateMessageValidator();
export class AnnotationConfigUpdateResponseValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'AnnotationConfigUpdateResponse: Expected object, got undefined object for AnnotationConfigUpdateResponseValidator' };
        }
        if (obj.token === undefined) {
            return { success: false, error: 'AnnotationConfigUpdateResponse: Required field "token" is missing' };
        }
        else if (typeof obj.token !== 'string') {
            return { success: false, error: 'AnnotationConfigUpdateResponse: Required field "token" is wrong type' };
        }
        if ((obj.success !== undefined) && (typeof obj.success !== 'boolean')) {
            return { success: false, error: 'AnnotationConfigUpdateResponse: Optional field "success" is wrong type' };
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'AnnotationConfigUpdateResponse: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'AnnotationConfigUpdateResponse: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'AnnotationConfigUpdateResponse: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!AnnotationConfigUpdateResponse.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "AnnotationConfigUpdateResponse"' };
        }
        return { success: true };
    }
}
export const annotationConfigUpdateResponseValidatorInstance = new AnnotationConfigUpdateResponseValidator();
export class BatchedMessageValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'BatchedMessage: Expected object, got undefined object for BatchedMessageValidator' };
        }
        if (obj.messages === undefined) {
            return { success: false, error: 'BatchedMessage: Required field "messages" is missing' };
        }
        else {
            const result = validateArray(obj.messages, 1, messageValidatorInstance, '{Message}');
            if (!result.success) {
                result.error = "BatchedMessage.messages: " + result.error;
                return result;
            }
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'BatchedMessage: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'BatchedMessage: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'BatchedMessage: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!BatchedMessage.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "BatchedMessage"' };
        }
        return { success: true };
    }
}
export const batchedMessageValidatorInstance = new BatchedMessageValidator();
export class SyncMessageValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'SyncMessage: Expected object, got undefined object for SyncMessageValidator' };
        }
        if ((obj.senderId !== undefined) && (typeof obj.senderId !== 'string')) {
            return { success: false, error: 'SyncMessage: Optional field "senderId" is wrong type' };
        }
        if ((obj.seq !== undefined) && (typeof obj.seq !== 'number')) {
            return { success: false, error: 'SyncMessage: Optional field "seq" is wrong type' };
        }
        if (obj.ops === undefined) {
            return { success: false, error: 'SyncMessage: Required field "ops" is missing' };
        }
        else {
            const result = validateArray(obj.ops, 1, operationValidatorInstance, '{Operation}');
            if (!result.success) {
                result.error = "SyncMessage.ops: " + result.error;
                return result;
            }
        }
        if ((obj.batchId !== undefined) && (typeof obj.batchId !== 'string')) {
            return { success: false, error: 'SyncMessage: Optional field "batchId" is wrong type' };
        }
        if ((obj.groupId !== undefined) && (typeof obj.groupId !== 'string')) {
            return { success: false, error: 'SyncMessage: Optional field "groupId" is wrong type' };
        }
        if ((obj.batchComplete !== undefined) && (typeof obj.batchComplete !== 'boolean')) {
            return { success: false, error: 'SyncMessage: Optional field "batchComplete" is wrong type' };
        }
        if ((obj.groupComplete !== undefined) && (typeof obj.groupComplete !== 'boolean')) {
            return { success: false, error: 'SyncMessage: Optional field "groupComplete" is wrong type' };
        }
        if ((obj.batchSize !== undefined) && (typeof obj.batchSize !== 'number')) {
            return { success: false, error: 'SyncMessage: Optional field "batchSize" is wrong type' };
        }
        if ((obj.groupSize !== undefined) && (typeof obj.groupSize !== 'number')) {
            return { success: false, error: 'SyncMessage: Optional field "groupSize" is wrong type' };
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'SyncMessage: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'SyncMessage: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'SyncMessage: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!SyncMessage.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "SyncMessage"' };
        }
        return { success: true };
    }
}
export const syncMessageValidatorInstance = new SyncMessageValidator();
export class MicroSyncMessageValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'MicroSyncMessage: Expected object, got undefined object for MicroSyncMessageValidator' };
        }
        if (obj.item === undefined) {
            return { success: false, error: 'MicroSyncMessage: Required field "item" is missing' };
        }
        else {
            const result = itemValidatorInstance.validate(obj.item);
            if (!result.success) {
                result.error = "MicroSyncMessage.item: " + result.error;
                return result;
            }
        }
        if ((obj.seq !== undefined) && (typeof obj.seq !== 'number')) {
            return { success: false, error: 'MicroSyncMessage: Optional field "seq" is wrong type' };
        }
        if ((obj.opType !== undefined) && (typeof obj.opType !== 'string')) {
            return { success: false, error: 'MicroSyncMessage: Optional field "opType" is wrong type' };
        }
        if (obj.parentPath !== undefined) {
            const result = validateArray(obj.parentPath, 1, undefined, 'string');
            if (!result.success) {
                result.error = "MicroSyncMessage.parentPath: " + result.error;
                return result;
            }
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'MicroSyncMessage: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'MicroSyncMessage: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'MicroSyncMessage: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!MicroSyncMessage.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "MicroSyncMessage"' };
        }
        return { success: true };
    }
}
export const microSyncMessageValidatorInstance = new MicroSyncMessageValidator();
export class SyncResponseValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'SyncResponse: Expected object, got undefined object for SyncResponseValidator' };
        }
        if ((obj.minimumSyncIntervalMs !== undefined) && (typeof obj.minimumSyncIntervalMs !== 'number')) {
            return { success: false, error: 'SyncResponse: Optional field "minimumSyncIntervalMs" is wrong type' };
        }
        if (obj.opErrors !== undefined) {
            const result = validateArray(obj.opErrors, 1, operationErrorValidatorInstance, '{OperationError}');
            if (!result.success) {
                result.error = "SyncResponse.opErrors: " + result.error;
                return result;
            }
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'SyncResponse: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'SyncResponse: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'SyncResponse: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!SyncResponse.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "SyncResponse"' };
        }
        return { success: true };
    }
}
export const syncResponseValidatorInstance = new SyncResponseValidator();
export class SessionDeleteMessageValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'SessionDeleteMessage: Expected object, got undefined object for SessionDeleteMessageValidator' };
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'SessionDeleteMessage: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'SessionDeleteMessage: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'SessionDeleteMessage: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!SessionDeleteMessage.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "SessionDeleteMessage"' };
        }
        return { success: true };
    }
}
export const sessionDeleteMessageValidatorInstance = new SessionDeleteMessageValidator();
export class AnnotationResultsMessageValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'AnnotationResultsMessage: Expected object, got undefined object for AnnotationResultsMessageValidator' };
        }
        if (obj.annotationType === undefined) {
            return { success: false, error: 'AnnotationResultsMessage: Required field "annotationType" is missing' };
        }
        else if (typeof obj.annotationType !== 'string') {
            return { success: false, error: 'AnnotationResultsMessage: Required field "annotationType" is wrong type' };
        }
        if ((obj.areApologies !== undefined) && (typeof obj.areApologies !== 'boolean')) {
            return { success: false, error: 'AnnotationResultsMessage: Optional field "areApologies" is wrong type' };
        }
        if ((obj.senderId !== undefined) && (typeof obj.senderId !== 'string')) {
            return { success: false, error: 'AnnotationResultsMessage: Optional field "senderId" is wrong type' };
        }
        if ((obj.seq !== undefined) && (typeof obj.seq !== 'number')) {
            return { success: false, error: 'AnnotationResultsMessage: Optional field "seq" is wrong type' };
        }
        if (obj.ops === undefined) {
            return { success: false, error: 'AnnotationResultsMessage: Required field "ops" is missing' };
        }
        else {
            const result = validateArray(obj.ops, 1, operationValidatorInstance, '{Operation}');
            if (!result.success) {
                result.error = "AnnotationResultsMessage.ops: " + result.error;
                return result;
            }
        }
        if ((obj.batchId !== undefined) && (typeof obj.batchId !== 'string')) {
            return { success: false, error: 'AnnotationResultsMessage: Optional field "batchId" is wrong type' };
        }
        if ((obj.groupId !== undefined) && (typeof obj.groupId !== 'string')) {
            return { success: false, error: 'AnnotationResultsMessage: Optional field "groupId" is wrong type' };
        }
        if ((obj.batchComplete !== undefined) && (typeof obj.batchComplete !== 'boolean')) {
            return { success: false, error: 'AnnotationResultsMessage: Optional field "batchComplete" is wrong type' };
        }
        if ((obj.groupComplete !== undefined) && (typeof obj.groupComplete !== 'boolean')) {
            return { success: false, error: 'AnnotationResultsMessage: Optional field "groupComplete" is wrong type' };
        }
        if ((obj.batchSize !== undefined) && (typeof obj.batchSize !== 'number')) {
            return { success: false, error: 'AnnotationResultsMessage: Optional field "batchSize" is wrong type' };
        }
        if ((obj.groupSize !== undefined) && (typeof obj.groupSize !== 'number')) {
            return { success: false, error: 'AnnotationResultsMessage: Optional field "groupSize" is wrong type' };
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'AnnotationResultsMessage: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'AnnotationResultsMessage: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'AnnotationResultsMessage: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!AnnotationResultsMessage.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "AnnotationResultsMessage"' };
        }
        return { success: true };
    }
}
export const annotationResultsMessageValidatorInstance = new AnnotationResultsMessageValidator();
export class TokenProvisionMessageValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'TokenProvisionMessage: Expected object, got undefined object for TokenProvisionMessageValidator' };
        }
        if ((obj.authToken !== undefined) && (typeof obj.authToken !== 'string')) {
            return { success: false, error: 'TokenProvisionMessage: Optional field "authToken" is wrong type' };
        }
        if ((obj.isPostTransformPft !== undefined) && (typeof obj.isPostTransformPft !== 'boolean')) {
            return { success: false, error: 'TokenProvisionMessage: Optional field "isPostTransformPft" is wrong type' };
        }
        if ((obj.version !== undefined) && (typeof obj.version !== 'number')) {
            return { success: false, error: 'TokenProvisionMessage: Optional field "version" is wrong type' };
        }
        if ((obj.claimsVersion !== undefined) && (typeof obj.claimsVersion !== 'number')) {
            return { success: false, error: 'TokenProvisionMessage: Optional field "claimsVersion" is wrong type' };
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'TokenProvisionMessage: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'TokenProvisionMessage: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'TokenProvisionMessage: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!TokenProvisionMessage.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "TokenProvisionMessage"' };
        }
        return { success: true };
    }
}
export const tokenProvisionMessageValidatorInstance = new TokenProvisionMessageValidator();
export class TokenFailureMessageValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'TokenFailureMessage: Expected object, got undefined object for TokenFailureMessageValidator' };
        }
        if ((obj.version !== undefined) && (typeof obj.version !== 'number')) {
            return { success: false, error: 'TokenFailureMessage: Optional field "version" is wrong type' };
        }
        if ((obj.claimsVersion !== undefined) && (typeof obj.claimsVersion !== 'number')) {
            return { success: false, error: 'TokenFailureMessage: Optional field "claimsVersion" is wrong type' };
        }
        if ((obj.reason !== undefined) && (typeof obj.reason !== 'string')) {
            return { success: false, error: 'TokenFailureMessage: Optional field "reason" is wrong type' };
        }
        if ((obj.clientHandlesResponse !== undefined) && (typeof obj.clientHandlesResponse !== 'boolean')) {
            return { success: false, error: 'TokenFailureMessage: Optional field "clientHandlesResponse" is wrong type' };
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'TokenFailureMessage: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'TokenFailureMessage: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'TokenFailureMessage: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!TokenFailureMessage.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "TokenFailureMessage"' };
        }
        return { success: true };
    }
}
export const tokenFailureMessageValidatorInstance = new TokenFailureMessageValidator();
export class TokenProvisionResponseValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'TokenProvisionResponse: Expected object, got undefined object for TokenProvisionResponseValidator' };
        }
        if ((obj.tokenExpirationTime !== undefined) && (typeof obj.tokenExpirationTime !== 'number')) {
            return { success: false, error: 'TokenProvisionResponse: Optional field "tokenExpirationTime" is wrong type' };
        }
        if ((obj.tokenExpirationSeconds !== undefined) && (typeof obj.tokenExpirationSeconds !== 'number')) {
            return { success: false, error: 'TokenProvisionResponse: Optional field "tokenExpirationSeconds" is wrong type' };
        }
        if ((obj.tokenType !== undefined)) {
            const result = authTokenTypeValidatorInstance.validate(obj.tokenType);
            if (!result.success) {
                result.error = "TokenProvisionResponse.tokenType: " + result.error;
                return result;
            }
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'TokenProvisionResponse: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'TokenProvisionResponse: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'TokenProvisionResponse: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!TokenProvisionResponse.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "TokenProvisionResponse"' };
        }
        return { success: true };
    }
}
export const tokenProvisionResponseValidatorInstance = new TokenProvisionResponseValidator();
export class KeepAliveValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'KeepAlive: Expected object, got undefined object for KeepAliveValidator' };
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'KeepAlive: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'KeepAlive: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'KeepAlive: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!KeepAlive.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "KeepAlive"' };
        }
        return { success: true };
    }
}
export const keepAliveValidatorInstance = new KeepAliveValidator();
export class WorkflowGraphInitMessageValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'WorkflowGraphInitMessage: Expected object, got undefined object for WorkflowGraphInitMessageValidator' };
        }
        if (obj.upstreamRuntimeWorkflows === undefined) {
            return { success: false, error: 'WorkflowGraphInitMessage: Required field "upstreamRuntimeWorkflows" is missing' };
        }
        else {
            const result = validateArray(obj.upstreamRuntimeWorkflows, 1, workflowDefinitionBaseValidatorInstance, '{WorkflowDefinitionBase}');
            if (!result.success) {
                result.error = "WorkflowGraphInitMessage.upstreamRuntimeWorkflows: " + result.error;
                return result;
            }
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'WorkflowGraphInitMessage: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'WorkflowGraphInitMessage: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'WorkflowGraphInitMessage: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!WorkflowGraphInitMessage.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "WorkflowGraphInitMessage"' };
        }
        return { success: true };
    }
}
export const workflowGraphInitMessageValidatorInstance = new WorkflowGraphInitMessageValidator();
export class WorkflowGraphInitResponseValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'WorkflowGraphInitResponse: Expected object, got undefined object for WorkflowGraphInitResponseValidator' };
        }
        if (obj.downstreamRuntimeWorkflows === undefined) {
            return { success: false, error: 'WorkflowGraphInitResponse: Required field "downstreamRuntimeWorkflows" is missing' };
        }
        else {
            const result = validateArray(obj.downstreamRuntimeWorkflows, 1, workflowDefinitionBaseValidatorInstance, '{WorkflowDefinitionBase}');
            if (!result.success) {
                result.error = "WorkflowGraphInitResponse.downstreamRuntimeWorkflows: " + result.error;
                return result;
            }
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'WorkflowGraphInitResponse: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'WorkflowGraphInitResponse: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'WorkflowGraphInitResponse: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!WorkflowGraphInitResponse.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "WorkflowGraphInitResponse"' };
        }
        return { success: true };
    }
}
export const workflowGraphInitResponseValidatorInstance = new WorkflowGraphInitResponseValidator();
export class WorkflowExecutionCompleteMessageValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'WorkflowExecutionCompleteMessage: Expected object, got undefined object for WorkflowExecutionCompleteMessageValidator' };
        }
        if (obj.workflowId === undefined) {
            return { success: false, error: 'WorkflowExecutionCompleteMessage: Required field "workflowId" is missing' };
        }
        else if (typeof obj.workflowId !== 'string') {
            return { success: false, error: 'WorkflowExecutionCompleteMessage: Required field "workflowId" is wrong type' };
        }
        if (obj.contextId === undefined) {
            return { success: false, error: 'WorkflowExecutionCompleteMessage: Required field "contextId" is missing' };
        }
        else if (typeof obj.contextId !== 'string') {
            return { success: false, error: 'WorkflowExecutionCompleteMessage: Required field "contextId" is wrong type' };
        }
        if ((obj.senderId !== undefined) && (typeof obj.senderId !== 'string')) {
            return { success: false, error: 'WorkflowExecutionCompleteMessage: Optional field "senderId" is wrong type' };
        }
        if ((obj.seq !== undefined) && (typeof obj.seq !== 'number')) {
            return { success: false, error: 'WorkflowExecutionCompleteMessage: Optional field "seq" is wrong type' };
        }
        if (obj.ops === undefined) {
            return { success: false, error: 'WorkflowExecutionCompleteMessage: Required field "ops" is missing' };
        }
        else {
            const result = validateArray(obj.ops, 1, operationValidatorInstance, '{Operation}');
            if (!result.success) {
                result.error = "WorkflowExecutionCompleteMessage.ops: " + result.error;
                return result;
            }
        }
        if ((obj.batchId !== undefined) && (typeof obj.batchId !== 'string')) {
            return { success: false, error: 'WorkflowExecutionCompleteMessage: Optional field "batchId" is wrong type' };
        }
        if ((obj.groupId !== undefined) && (typeof obj.groupId !== 'string')) {
            return { success: false, error: 'WorkflowExecutionCompleteMessage: Optional field "groupId" is wrong type' };
        }
        if ((obj.batchComplete !== undefined) && (typeof obj.batchComplete !== 'boolean')) {
            return { success: false, error: 'WorkflowExecutionCompleteMessage: Optional field "batchComplete" is wrong type' };
        }
        if ((obj.groupComplete !== undefined) && (typeof obj.groupComplete !== 'boolean')) {
            return { success: false, error: 'WorkflowExecutionCompleteMessage: Optional field "groupComplete" is wrong type' };
        }
        if ((obj.batchSize !== undefined) && (typeof obj.batchSize !== 'number')) {
            return { success: false, error: 'WorkflowExecutionCompleteMessage: Optional field "batchSize" is wrong type' };
        }
        if ((obj.groupSize !== undefined) && (typeof obj.groupSize !== 'number')) {
            return { success: false, error: 'WorkflowExecutionCompleteMessage: Optional field "groupSize" is wrong type' };
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'WorkflowExecutionCompleteMessage: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'WorkflowExecutionCompleteMessage: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'WorkflowExecutionCompleteMessage: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!WorkflowExecutionCompleteMessage.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "WorkflowExecutionCompleteMessage"' };
        }
        return { success: true };
    }
}
export const workflowExecutionCompleteMessageValidatorInstance = new WorkflowExecutionCompleteMessageValidator();
export class SeedingStatusChangeMessageValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'SeedingStatusChangeMessage: Expected object, got undefined object for SeedingStatusChangeMessageValidator' };
        }
        if (obj.newStatus === undefined) {
            return { success: false, error: 'SeedingStatusChangeMessage: Required field "newStatus" is missing' };
        }
        else {
            const result = seedingProgressCodeValidatorInstance.validate(obj.newStatus);
            if (!result.success) {
                result.error = "SeedingStatusChangeMessage.newStatus: " + result.error;
                return result;
            }
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'SeedingStatusChangeMessage: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'SeedingStatusChangeMessage: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'SeedingStatusChangeMessage: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!SeedingStatusChangeMessage.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "SeedingStatusChangeMessage"' };
        }
        return { success: true };
    }
}
export const seedingStatusChangeMessageValidatorInstance = new SeedingStatusChangeMessageValidator();
export class OAuth2InitV2MessageValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'OAuth2InitV2Message: Expected object, got undefined object for OAuth2InitV2MessageValidator' };
        }
        if (obj.tokenType === undefined) {
            return { success: false, error: 'OAuth2InitV2Message: Required field "tokenType" is missing' };
        }
        else {
            const result = authTokenTypeValidatorInstance.validate(obj.tokenType);
            if (!result.success) {
                result.error = "OAuth2InitV2Message.tokenType: " + result.error;
                return result;
            }
        }
        if ((obj.refererUrl !== undefined) && (typeof obj.refererUrl !== 'string')) {
            return { success: false, error: 'OAuth2InitV2Message: Optional field "refererUrl" is wrong type' };
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'OAuth2InitV2Message: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'OAuth2InitV2Message: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'OAuth2InitV2Message: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!OAuth2InitV2Message.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "OAuth2InitV2Message"' };
        }
        return { success: true };
    }
}
export const oAuth2InitV2MessageValidatorInstance = new OAuth2InitV2MessageValidator();
export class OAuth2InitV2ResponseValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'OAuth2InitV2Response: Expected object, got undefined object for OAuth2InitV2ResponseValidator' };
        }
        if (obj.loginStatus === undefined) {
            return { success: false, error: 'OAuth2InitV2Response: Required field "loginStatus" is missing' };
        }
        else {
            const result = oAuth2V2LoginStatusValidatorInstance.validate(obj.loginStatus);
            if (!result.success) {
                result.error = "OAuth2InitV2Response.loginStatus: " + result.error;
                return result;
            }
        }
        if (obj.statusCode === undefined) {
            return { success: false, error: 'OAuth2InitV2Response: Required field "statusCode" is missing' };
        }
        else if (typeof obj.statusCode !== 'number') {
            return { success: false, error: 'OAuth2InitV2Response: Required field "statusCode" is wrong type' };
        }
        if ((obj.redirectUrl !== undefined) && (typeof obj.redirectUrl !== 'string')) {
            return { success: false, error: 'OAuth2InitV2Response: Optional field "redirectUrl" is wrong type' };
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'OAuth2InitV2Response: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'OAuth2InitV2Response: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'OAuth2InitV2Response: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!OAuth2InitV2Response.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "OAuth2InitV2Response"' };
        }
        return { success: true };
    }
}
export const oAuth2InitV2ResponseValidatorInstance = new OAuth2InitV2ResponseValidator();
export class OAuth2InitMessageValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'OAuth2InitMessage: Expected object, got undefined object for OAuth2InitMessageValidator' };
        }
        if (obj.grantFlow === undefined) {
            return { success: false, error: 'OAuth2InitMessage: Required field "grantFlow" is missing' };
        }
        else {
            const result = oAuth2GrantFlowValidatorInstance.validate(obj.grantFlow);
            if (!result.success) {
                result.error = "OAuth2InitMessage.grantFlow: " + result.error;
                return result;
            }
        }
        if (obj.tokenType === undefined) {
            return { success: false, error: 'OAuth2InitMessage: Required field "tokenType" is missing' };
        }
        else {
            const result = authTokenTypeValidatorInstance.validate(obj.tokenType);
            if (!result.success) {
                result.error = "OAuth2InitMessage.tokenType: " + result.error;
                return result;
            }
        }
        if ((obj.refererUrl !== undefined) && (typeof obj.refererUrl !== 'string')) {
            return { success: false, error: 'OAuth2InitMessage: Optional field "refererUrl" is wrong type' };
        }
        if ((obj.refreshToken !== undefined) && (typeof obj.refreshToken !== 'string')) {
            return { success: false, error: 'OAuth2InitMessage: Optional field "refreshToken" is wrong type' };
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'OAuth2InitMessage: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'OAuth2InitMessage: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'OAuth2InitMessage: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!OAuth2InitMessage.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "OAuth2InitMessage"' };
        }
        return { success: true };
    }
}
export const oAuth2InitMessageValidatorInstance = new OAuth2InitMessageValidator();
export class OAuth2InitResponseValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'OAuth2InitResponse: Expected object, got undefined object for OAuth2InitResponseValidator' };
        }
        if (obj.statusCode === undefined) {
            return { success: false, error: 'OAuth2InitResponse: Required field "statusCode" is missing' };
        }
        else if (typeof obj.statusCode !== 'number') {
            return { success: false, error: 'OAuth2InitResponse: Required field "statusCode" is wrong type' };
        }
        if ((obj.redirectUrl !== undefined) && (typeof obj.redirectUrl !== 'string')) {
            return { success: false, error: 'OAuth2InitResponse: Optional field "redirectUrl" is wrong type' };
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'OAuth2InitResponse: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'OAuth2InitResponse: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'OAuth2InitResponse: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!OAuth2InitResponse.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "OAuth2InitResponse"' };
        }
        return { success: true };
    }
}
export const oAuth2InitResponseValidatorInstance = new OAuth2InitResponseValidator();
export class OAuth2CallbackMessageValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'OAuth2CallbackMessage: Expected object, got undefined object for OAuth2CallbackMessageValidator' };
        }
        if (obj.requestId === undefined) {
            return { success: false, error: 'OAuth2CallbackMessage: Required field "requestId" is missing' };
        }
        else if (typeof obj.requestId !== 'string') {
            return { success: false, error: 'OAuth2CallbackMessage: Required field "requestId" is wrong type' };
        }
        if (obj.authCode === undefined) {
            return { success: false, error: 'OAuth2CallbackMessage: Required field "authCode" is missing' };
        }
        else if (typeof obj.authCode !== 'string') {
            return { success: false, error: 'OAuth2CallbackMessage: Required field "authCode" is wrong type' };
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'OAuth2CallbackMessage: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'OAuth2CallbackMessage: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'OAuth2CallbackMessage: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!OAuth2CallbackMessage.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "OAuth2CallbackMessage"' };
        }
        return { success: true };
    }
}
export const oAuth2CallbackMessageValidatorInstance = new OAuth2CallbackMessageValidator();
export class BridgeMessageValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'BridgeMessage: Expected object, got undefined object for BridgeMessageValidator' };
        }
        if (obj.bridgeId === undefined) {
            return { success: false, error: 'BridgeMessage: Required field "bridgeId" is missing' };
        }
        else if (typeof obj.bridgeId !== 'string') {
            return { success: false, error: 'BridgeMessage: Required field "bridgeId" is wrong type' };
        }
        if (obj.docSessionId === undefined) {
            return { success: false, error: 'BridgeMessage: Required field "docSessionId" is missing' };
        }
        else if (typeof obj.docSessionId !== 'string') {
            return { success: false, error: 'BridgeMessage: Required field "docSessionId" is wrong type' };
        }
        if ((obj.messageType !== undefined) && (typeof obj.messageType !== 'string')) {
            return { success: false, error: 'BridgeMessage: Optional field "messageType" is wrong type' };
        }
        if ((obj.hostConfig !== undefined)) {
            const result = hostConfigValidatorInstance.validate(obj.hostConfig);
            if (!result.success) {
                result.error = "BridgeMessage.hostConfig: " + result.error;
                return result;
            }
        }
        if ((obj.message !== undefined)) {
            const result = messageValidatorInstance.validate(obj.message);
            if (!result.success) {
                result.error = "BridgeMessage.message: " + result.error;
                return result;
            }
        }
        if ((obj.response !== undefined)) {
            const result = responseValidatorInstance.validate(obj.response);
            if (!result.success) {
                result.error = "BridgeMessage.response: " + result.error;
                return result;
            }
        }
        if ((obj.seq !== undefined) && (typeof obj.seq !== 'number')) {
            return { success: false, error: 'BridgeMessage: Optional field "seq" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!BridgeMessage.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "BridgeMessage"' };
        }
        return { success: true };
    }
}
export const bridgeMessageValidatorInstance = new BridgeMessageValidator();
export class SessionConnectMessageValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'SessionConnectMessage: Expected object, got undefined object for SessionConnectMessageValidator' };
        }
        if (obj.isSeedingRequired === undefined) {
            return { success: false, error: 'SessionConnectMessage: Required field "isSeedingRequired" is missing' };
        }
        else if (typeof obj.isSeedingRequired !== 'boolean') {
            return { success: false, error: 'SessionConnectMessage: Required field "isSeedingRequired" is wrong type' };
        }
        if (obj.sessionUrl === undefined) {
            return { success: false, error: 'SessionConnectMessage: Required field "sessionUrl" is missing' };
        }
        else if (typeof obj.sessionUrl !== 'string') {
            return { success: false, error: 'SessionConnectMessage: Required field "sessionUrl" is wrong type' };
        }
        if (obj.origin === undefined) {
            return { success: false, error: 'SessionConnectMessage: Required field "origin" is missing' };
        }
        else if (typeof obj.origin !== 'string') {
            return { success: false, error: 'SessionConnectMessage: Required field "origin" is wrong type' };
        }
        if (obj.authToken === undefined) {
            return { success: false, error: 'SessionConnectMessage: Required field "authToken" is missing' };
        }
        else if (typeof obj.authToken !== 'string') {
            return { success: false, error: 'SessionConnectMessage: Required field "authToken" is wrong type' };
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'SessionConnectMessage: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'SessionConnectMessage: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'SessionConnectMessage: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!SessionConnectMessage.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "SessionConnectMessage"' };
        }
        return { success: true };
    }
}
export const sessionConnectMessageValidatorInstance = new SessionConnectMessageValidator();
export class SessionDisconnectMessageValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'SessionDisconnectMessage: Expected object, got undefined object for SessionDisconnectMessageValidator' };
        }
        if (obj.error === undefined) {
            return { success: false, error: 'SessionDisconnectMessage: Required field "error" is missing' };
        }
        else if (typeof obj.error !== 'string') {
            return { success: false, error: 'SessionDisconnectMessage: Required field "error" is wrong type' };
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'SessionDisconnectMessage: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'SessionDisconnectMessage: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'SessionDisconnectMessage: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!SessionDisconnectMessage.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "SessionDisconnectMessage"' };
        }
        return { success: true };
    }
}
export const sessionDisconnectMessageValidatorInstance = new SessionDisconnectMessageValidator();
export class SessionReconnectMessageValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'SessionReconnectMessage: Expected object, got undefined object for SessionReconnectMessageValidator' };
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'SessionReconnectMessage: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'SessionReconnectMessage: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'SessionReconnectMessage: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!SessionReconnectMessage.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "SessionReconnectMessage"' };
        }
        return { success: true };
    }
}
export const sessionReconnectMessageValidatorInstance = new SessionReconnectMessageValidator();
export class SubmittedCustomMessageValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'SubmittedCustomMessage: Expected object, got undefined object for SubmittedCustomMessageValidator' };
        }
        if ((obj.customMessage !== undefined)) {
            const result = messageValidatorInstance.validate(obj.customMessage);
            if (!result.success) {
                result.error = "SubmittedCustomMessage.customMessage: " + result.error;
                return result;
            }
        }
        if (obj.binaryMessage !== undefined) {
            const result = validateArray(obj.binaryMessage, 1, undefined, 'number');
            if (!result.success) {
                result.error = "SubmittedCustomMessage.binaryMessage: " + result.error;
                return result;
            }
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'SubmittedCustomMessage: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'SubmittedCustomMessage: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'SubmittedCustomMessage: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!SubmittedCustomMessage.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "SubmittedCustomMessage"' };
        }
        return { success: true };
    }
}
export const submittedCustomMessageValidatorInstance = new SubmittedCustomMessageValidator();
export class ServerAuthenticationStateChangeMessageValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'ServerAuthenticationStateChangeMessage: Expected object, got undefined object for ServerAuthenticationStateChangeMessageValidator' };
        }
        if (obj.serverAuthenticationState === undefined) {
            return { success: false, error: 'ServerAuthenticationStateChangeMessage: Required field "serverAuthenticationState" is missing' };
        }
        else {
            const result = serverAuthenticationStateValidatorInstance.validate(obj.serverAuthenticationState);
            if (!result.success) {
                result.error = "ServerAuthenticationStateChangeMessage.serverAuthenticationState: " + result.error;
                return result;
            }
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'ServerAuthenticationStateChangeMessage: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'ServerAuthenticationStateChangeMessage: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'ServerAuthenticationStateChangeMessage: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!ServerAuthenticationStateChangeMessage.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "ServerAuthenticationStateChangeMessage"' };
        }
        return { success: true };
    }
}
export const serverAuthenticationStateChangeMessageValidatorInstance = new ServerAuthenticationStateChangeMessageValidator();
export class ClaimsChallengeMessageValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'ClaimsChallengeMessage: Expected object, got undefined object for ClaimsChallengeMessageValidator' };
        }
        if ((obj.error !== undefined) && (typeof obj.error !== 'string')) {
            return { success: false, error: 'ClaimsChallengeMessage: Optional field "error" is wrong type' };
        }
        if ((obj.claims !== undefined) && (typeof obj.claims !== 'string')) {
            return { success: false, error: 'ClaimsChallengeMessage: Optional field "claims" is wrong type' };
        }
        if ((obj.claimsVersion !== undefined) && (typeof obj.claimsVersion !== 'number')) {
            return { success: false, error: 'ClaimsChallengeMessage: Optional field "claimsVersion" is wrong type' };
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'ClaimsChallengeMessage: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'ClaimsChallengeMessage: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'ClaimsChallengeMessage: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!ClaimsChallengeMessage.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "ClaimsChallengeMessage"' };
        }
        return { success: true };
    }
}
export const claimsChallengeMessageValidatorInstance = new ClaimsChallengeMessageValidator();
export class BlobUploadResponseValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'BlobUploadResponse: Expected object, got undefined object for BlobUploadResponseValidator' };
        }
        if (obj.blob === undefined) {
            return { success: false, error: 'BlobUploadResponse: Required field "blob" is missing' };
        }
        else {
            const result = blobValidatorInstance.validate(obj.blob);
            if (!result.success) {
                result.error = "BlobUploadResponse.blob: " + result.error;
                return result;
            }
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'BlobUploadResponse: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'BlobUploadResponse: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'BlobUploadResponse: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!BlobUploadResponse.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "BlobUploadResponse"' };
        }
        return { success: true };
    }
}
export const blobUploadResponseValidatorInstance = new BlobUploadResponseValidator();
export class GetPluginsMetadataMessageValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'GetPluginsMetadataMessage: Expected object, got undefined object for GetPluginsMetadataMessageValidator' };
        }
        if (obj.sources !== undefined) {
            const result = validateArray(obj.sources, 1, undefined, 'string');
            if (!result.success) {
                result.error = "GetPluginsMetadataMessage.sources: " + result.error;
                return result;
            }
        }
        if ((obj.platform !== undefined) && (typeof obj.platform !== 'string')) {
            return { success: false, error: 'GetPluginsMetadataMessage: Optional field "platform" is wrong type' };
        }
        if (obj.plugins !== undefined) {
            const result = validateArray(obj.plugins, 1, pluginInfoValidatorInstance, '{PluginInfo}');
            if (!result.success) {
                result.error = "GetPluginsMetadataMessage.plugins: " + result.error;
                return result;
            }
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'GetPluginsMetadataMessage: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'GetPluginsMetadataMessage: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'GetPluginsMetadataMessage: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!GetPluginsMetadataMessage.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "GetPluginsMetadataMessage"' };
        }
        return { success: true };
    }
}
export const getPluginsMetadataMessageValidatorInstance = new GetPluginsMetadataMessageValidator();
export class GetPluginsMetadataResponseValidator {
    validate(obj) {
        if (!obj) {
            return { success: false, error: 'GetPluginsMetadataResponse: Expected object, got undefined object for GetPluginsMetadataResponseValidator' };
        }
        if (obj.result === undefined) {
            return { success: false, error: 'GetPluginsMetadataResponse: Required field "result" is missing' };
        }
        else {
            const result = validateArray(obj.result, 1, pluginMetadataValidatorInstance, '{PluginMetadata}');
            if (!result.success) {
                result.error = "GetPluginsMetadataResponse.result: " + result.error;
                return result;
            }
        }
        if ((obj.messageId !== undefined) && (typeof obj.messageId !== 'string')) {
            return { success: false, error: 'GetPluginsMetadataResponse: Optional field "messageId" is wrong type' };
        }
        if ((obj.cv !== undefined) && (typeof obj.cv !== 'string')) {
            return { success: false, error: 'GetPluginsMetadataResponse: Optional field "cv" is wrong type' };
        }
        if ((obj.bridgeId !== undefined) && (typeof obj.bridgeId !== 'string')) {
            return { success: false, error: 'GetPluginsMetadataResponse: Optional field "bridgeId" is wrong type' };
        }
        const headerRes = schemaObjectHeaderValidatorInstance.validate(obj.H_);
        if (!headerRes.success) {
            return headerRes;
        }
        else if (!GetPluginsMetadataResponse.typeGuard(obj)) {
            return { success: false, error: 'Types do not match for "GetPluginsMetadataResponse"' };
        }
        return { success: true };
    }
}
export const getPluginsMetadataResponseValidatorInstance = new GetPluginsMetadataResponseValidator();
export class ExecutionErrorCodeValidator {
    validate(value) {
        if (!ExecutionErrorCodeValidator.validValues.has(value)) {
            return { success: false, error: 'Invalid value for enum "ExecutionErrorCode"' };
        }
        return { success: true };
    }
}
ExecutionErrorCodeValidator.validValues = new Set([ExecutionErrorCode.ServerError, ExecutionErrorCode.WorkflowDisabled, ExecutionErrorCode.TokenNotReady, ExecutionErrorCode.FlightNotReady, ExecutionErrorCode.ContextNotReady, ExecutionErrorCode.WorkflowExcluded, ExecutionErrorCode.WorkflowExecutionTimeout, ExecutionErrorCode.LambdaExecutionError, ExecutionErrorCode.UnexpectedOutput, ExecutionErrorCode.FailedToFetchInputs]);
export const executionErrorCodeValidatorInstance = new ExecutionErrorCodeValidator();
export class GetAnnotationsClientErrorCodeValidator {
    validate(value) {
        if (!GetAnnotationsClientErrorCodeValidator.validValues.has(value)) {
            return { success: false, error: 'Invalid value for enum "GetAnnotationsClientErrorCode"' };
        }
        return { success: true };
    }
}
GetAnnotationsClientErrorCodeValidator.validValues = new Set([GetAnnotationsClientErrorCode.Unknown, GetAnnotationsClientErrorCode.InvalidRequest, GetAnnotationsClientErrorCode.InvalidResponse, GetAnnotationsClientErrorCode.RuntimeNotInitialized, GetAnnotationsClientErrorCode.RequestCancelled, GetAnnotationsClientErrorCode.ResponseReceivedAfterFinalResponse]);
export const getAnnotationsClientErrorCodeValidatorInstance = new GetAnnotationsClientErrorCodeValidator();
export class ErrorResponseCodeValidator {
    validate(value) {
        if (!ErrorResponseCodeValidator.validValues.has(value)) {
            return { success: false, error: 'Invalid value for enum "ErrorResponseCode"' };
        }
        return { success: true };
    }
}
ErrorResponseCodeValidator.validValues = new Set([ErrorResponseCode.Unknown, ErrorResponseCode.Found, ErrorResponseCode.BadRequest, ErrorResponseCode.Unauthorized, ErrorResponseCode.Forbidden, ErrorResponseCode.NotFound, ErrorResponseCode.RequestTimeout, ErrorResponseCode.Conflict, ErrorResponseCode.Gone, ErrorResponseCode.RequestEntityTooLarge, ErrorResponseCode.UnsupportedMediaType, ErrorResponseCode.UnprocessableContent, ErrorResponseCode.TooManyRequests, ErrorResponseCode.SocketDisconnect, ErrorResponseCode.InternalServerError, ErrorResponseCode.ServiceUnavailable, ErrorResponseCode.GatewayTimeout, ErrorResponseCode.UnsupportedMessage, ErrorResponseCode.Cancelled, ErrorResponseCode.EgressError, ErrorResponseCode.SyncMessageException, ErrorResponseCode.SyncMessageUnsupported, ErrorResponseCode.SyncMessageUnexpectedSeed, ErrorResponseCode.SyncMessageUnsupportedBatch, ErrorResponseCode.SyncMessageQueueFull, ErrorResponseCode.SyncMessageTooLateOrDuplicate, ErrorResponseCode.SyncMessageGroupIdMismatch, ErrorResponseCode.SyncMessageGroupStop, ErrorResponseCode.SyncMessageLost, ErrorResponseCode.SyncMessageUnprocessedDuplicate, ErrorResponseCode.SyncMessageSessionClosed, ErrorResponseCode.SyncMessageAbandoned, ErrorResponseCode.SyncMessageTooManyDeltaOperations, ErrorResponseCode.SyncMessageSessionSizeLimitExceeded, ErrorResponseCode.TokenValidationError, ErrorResponseCode.TokenDecryptError, ErrorResponseCode.TokenTypeError, ErrorResponseCode.TokenUserBlocked, ErrorResponseCode.AnnotationActivationInvalidType, ErrorResponseCode.AnnotationReleaseTokenNotFound]);
export const errorResponseCodeValidatorInstance = new ErrorResponseCodeValidator();
export class SessionLongPollMessageTypeValidator {
    validate(value) {
        if (!SessionLongPollMessageTypeValidator.validValues.has(value)) {
            return { success: false, error: 'Invalid value for enum "SessionLongPollMessageType"' };
        }
        return { success: true };
    }
}
SessionLongPollMessageTypeValidator.validValues = new Set([SessionLongPollMessageType.UnKnown, SessionLongPollMessageType.Start, SessionLongPollMessageType.Regular, SessionLongPollMessageType.CheckConnection, SessionLongPollMessageType.PostEgress, SessionLongPollMessageType.TimeoutResend, SessionLongPollMessageType.FailResend]);
export const sessionLongPollMessageTypeValidatorInstance = new SessionLongPollMessageTypeValidator();
export class SessionSwapReasonValidator {
    validate(value) {
        if (!SessionSwapReasonValidator.validValues.has(value)) {
            return { success: false, error: 'Invalid value for enum "SessionSwapReason"' };
        }
        return { success: true };
    }
}
SessionSwapReasonValidator.validValues = new Set([SessionSwapReason.IdentityChange]);
export const sessionSwapReasonValidatorInstance = new SessionSwapReasonValidator();
export class AnnotationResultStateValidator {
    validate(value) {
        if (!AnnotationResultStateValidator.validValues.has(value)) {
            return { success: false, error: 'Invalid value for enum "AnnotationResultState"' };
        }
        return { success: true };
    }
}
AnnotationResultStateValidator.validValues = new Set([AnnotationResultState.Idle, AnnotationResultState.Pending]);
export const annotationResultStateValidatorInstance = new AnnotationResultStateValidator();
export class SeedingProgressCodeValidator {
    validate(value) {
        if (!SeedingProgressCodeValidator.validValues.has(value)) {
            return { success: false, error: 'Invalid value for enum "SeedingProgressCode"' };
        }
        return { success: true };
    }
}
SeedingProgressCodeValidator.validValues = new Set([SeedingProgressCode.NotStarted, SeedingProgressCode.Started, SeedingProgressCode.Incomplete, SeedingProgressCode.Finished]);
export const seedingProgressCodeValidatorInstance = new SeedingProgressCodeValidator();
//# sourceMappingURL=messages-validator.g.js.map